import auth0 from "auth0-js";
import { useEffect } from "react";
import { signIn } from "next-auth/react";

const useAuthAuth = () => {
    useEffect(() => {
        checkSession();
    }, []);

    const checkSession = async () => {
        const auth = new auth0.WebAuth({
            domain: process.env.NEXT_PUBLIC_AUTH0_ISSUER_BASE_URL!.replace(
                "https://",
                "",
            ),
            clientID: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID!,
            redirectUri: window.origin + "/api/auth/callback/auth0",
            audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE!,
            scope: "openid email profile user:read",
            responseType: "token id_token",
        });

        auth.checkSession({}, (err, authResult) => {
            if (!err && authResult?.accessToken) {
                signIn("auth0", {
                    callbackUrl: "/",
                    authorizationParams: {
                        prompt: "none",
                    },
                });
            }
        });
    };
};

export default useAuthAuth;
